import React from 'react';
import LanguageSelector from './topbar/LanguageSelector';
import DateTime from './topbar/DateTime';

const TopBar = () => {
  return (
    <div className="w-full flex justify-center bg-gray-100">
      <div className="w-full max-w-[1759px]">
        <div className="max-w-[1762px] mx-auto px-4 h-[42px] flex justify-between items-center">
          <DateTime />
          <LanguageSelector />
        </div>
      </div>
    </div>
  );
};

export default TopBar;